export const SidebarReturn = () => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_7974_16277"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="34"
        height="34"
      >
        <rect width="34" height="34" rx="17" fill="white" />
      </mask>
      <g mask="url(#mask0_7974_16277)">
        <rect
          x="0.5"
          y="0.5"
          width="33"
          height="33"
          rx="16.5"
          fill="var(--white-marble)"
          stroke="var(--neutral-300)"
        />
        <rect
          x="-2.04004"
          y="32.64"
          width="4.76"
          height="4.76"
          rx="2.38"
          fill="var(--white-marble)"
        />
      </g>
      <g clipPath="url(#clip0_7974_16277)">
        <path
          d="M12.5 11.0001H21.5C22.3284 11.0001 23 11.6716 23 12.5001V21.5001C23 22.3285 22.3284 23.0001 21.5 23.0001H12.5C11.6716 23.0001 11 22.3285 11 21.5001V12.5001C11 11.6716 11.6716 11.0001 12.5 11.0001Z"
          stroke="var(--input-label)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.25 11.0001V23.0001"
          stroke="var(--input-label)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.75 15.5001L16.25 17.0001L14.75 18.5001"
          stroke="var(--input-label)"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7974_16277">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="matrix(-1 0 0 1 26 8.00006)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
